import React from 'react';
import Lti from '../../utils/lti';

export default class LearningModule extends React.Component {
  render() {
    return <Lti uuid={this.props.match.params.uuid} />;
  }
}
